// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { connect } from 'react-redux'
import { func, string } from 'prop-types'
import { Field } from 'redux-form'
import { AutoSuggest } from 'components/Form'
import { assembleQuery, fetchRadioModulationModelNumbers } from 'helpers/api'

const RadioModelNumber = ({ bandId, handleSelection, idRoot, name }) => {
  const fetchRadioModulationModelNumbersContaining = value => {
    const query = [{
      field: 'modelNumberContains',
      value,
    }]

    if (bandId) {
      query.push({
        field: 'filterByBandId',
        value: bandId,
      })
    }

    return fetchRadioModulationModelNumbers(assembleQuery(query))
  }

  return (
    <Field
      component={AutoSuggest}
      fetchSuggestions={fetchRadioModulationModelNumbersContaining}
      handleSelection={handleSelection}
      id={`${idRoot}-model-number`}
      label={'Model'}
      name={name}
      optionKey={null}
      placeholder={'Model'} />
  )
}

RadioModelNumber.propTypes = {
  bandId: string,
  handleSelection: func.isRequired,
  idRoot: string.isRequired,
  name: string.isRequired,
  sourceForm: string,
}

const mapStateToProps = ({ form }, { sourceForm }) => {
  const bandId = form[sourceForm]?.values?.bandId || ''

  return {
    bandId,
    sourceForm,
  }
}

export default connect(
  mapStateToProps,
  null,
)(RadioModelNumber)
